import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { SliderViewComponent } from '../slider-view/slider-view.component';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  imports: [],
})
export class SliderComponent implements AfterContentInit {
  @ContentChildren(SliderViewComponent)
  sliderViews: QueryList<SliderViewComponent>;
  currentActive: SliderViewComponent;
  currentIndex: number;

  ngAfterContentInit(): void {
    this.setActive(this.sliderViews.first);
  }

  setActive(active: SliderViewComponent) {
    if (this.currentActive) this.currentActive.active = false;
    this.currentActive = active;
    this.currentActive.active = true;
    this.currentIndex = this.sliderViews
      .toArray()
      .findIndex((sliderView: SliderViewComponent) => sliderView == this.currentActive);
  }

  setActiveIndex(index: number) {
    this.setActive(this.sliderViews.get(index));
  }

  prev() {
    if (this.currentIndex <= 0) return;
    this.setActive(this.sliderViews.get(this.currentIndex - 1));
  }

  next() {
    if (this.currentIndex >= this.sliderViews.length - 1) return;
    this.setActive(this.sliderViews.get(this.currentIndex + 1));
  }
}
